module.exports = __webpack_public_path__ + "static/media/carousel-0.073b9540.jpg";